import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import ImageUploads from "../../util/ImageUploads";
import AppConstants from "../../../appConstants";

const CHECKBOXES = {
  Name: false,
  Phone: false,
  Email: false,
  "Room Key": false,
};

function AddWifiSqueeze() {
  const location = useLocation();
  const { details } = location?.state || {};
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { current } = useSelector((state) => state.user);

  const initialField = {
    userId: current?.id,
    squeezId: details?.id || "",
    companyName: details?.company_name || "",
    logo: details?.logo || "",
    backgroundImage: details?.background_image || "",
    qrImage: details?.qr_image || "",
    squeezeType: details?.squeeze_type || "Hunt",
    headerColor: details?.header_color || "",
    fieldsName: details?.fields_name || CHECKBOXES,
    isLogoUpload: false,
    isBgUpload: false,
    isQRUpload: false,
    // radiusUrl: "",
    // welcomeUrl: "",
    // successUrl: "",
  };

  const [values, setValues] = useState(initialField);

  const handleSubmit = async () => {
    toast.dismiss();
    setLoading(true);
    values.logo = values.isLogoUpload ? values.logo : "";
    values.backgroundImage = values.isBgUpload ? values.backgroundImage : "";
    values.qrImage = values.isQRUpload ? values.qrImage : "";

    const resp = await authCall("createWifiSqueeze", values);
    if (resp?.type === "success") {
      setLoading("");
      toast.success(resp?.message);
      navigate(AppConstants.routes.admin.listWifiSqueeze);
    } else {
      setLoading("");
      toast.error(resp?.message);
    }
  };

  const getItemPhoto = (id, name, type) => (img) => {
    setValues({
      ...values,
      [name]: img,
      [type]: true,
    });
  };

  const handleChangeCheckBoxes = (e) => {
    const { checked, name } = e.target;
    setValues({
      ...values,
      fieldsName: { ...values.fieldsName, [name]: checked },
    });
  };

  return (
    <>
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">{details?.id ? 'Update' : 'Add'} Wifi Squeeze</div>

                {/* daily deals */}
                <div className="details-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div
                          className="main-heading2 mb-3 mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        ></div>
                        <div>
                          <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                            {/* company name */}
                            <div className="col-6">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Company Name
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={values?.companyName}
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    companyName: e.target.value,
                                  })
                                }
                              />
                            </div>

                            {/* logo */}
                            <div className="col-2">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Logo
                              </label>
                              <ImageUploads
                                getImage={getItemPhoto(
                                  values.id,
                                  "logo",
                                  "isLogoUpload"
                                )}
                                uploadedImage={values?.logo}
                                aspectRation={220 / 78}
                                croppedSize={{
                                  width: 220,
                                  height: 78,
                                  imageSmoothingQuality: "high",
                                }}
                              />
                            </div>

                            {/* background image */}
                            <div className="col-2">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Background
                              </label>
                              <ImageUploads
                                getImage={getItemPhoto(
                                  values.id,
                                  "backgroundImage",
                                  "isBgUpload"
                                )}
                                uploadedImage={values?.backgroundImage}
                                aspectRation={3 / 2}
                              />
                            </div>

                            {/* gr code */}
                            <div className="col-2">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                QR Code
                              </label>
                              <ImageUploads
                                getImage={getItemPhoto(
                                  values.id,
                                  "qrImage",
                                  "isQRUpload"
                                )}
                                uploadedImage={values?.qrImage}
                                aspectRation={3 / 2}
                              />
                            </div>
                          </div>

                          <div className="row gx-3 d-flex flex-wrap align-items-center mb-3 mt-1">
                            {/* version */}
                            <div className="col-3">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Version
                              </label>
                              <div className="fs-md-18 d-flex mb-3 gap-3">
                                <input
                                  type="radio"
                                  className="custom-radio m-0 companyType cursor-pointer"
                                  value="Safety"
                                  checked={values?.squeezeType === "Safety"}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      squeezeType: e.target.value,
                                    })
                                  }
                                />
                                <label>Safety</label>

                                <input
                                  type="radio"
                                  className="custom-radio m-0 companyType cursor-pointer"
                                  value="Hunt"
                                  checked={values?.squeezeType === "Hunt"}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      squeezeType: e.target.value,
                                    })
                                  }
                                />
                                <label>Hunt</label>
                              </div>
                            </div>
                            <div className="col-2">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-1 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Header Color
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={values?.headerColor}
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    headerColor: e.target.value,
                                  })
                                }
                              />
                            </div>
                            <div className="col-7">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Text Fields:
                              </label>

                              <div className="row">
                                {Object.keys(CHECKBOXES).map((el, index) => (
                                  <div key={index} className={`col-3`}>
                                    <div className="fs-md-18 d-flex mb-3 gap-2">
                                      <input
                                        type="checkbox"
                                        name={el}
                                        value={el}
                                        checked={values?.fieldsName?.[el] || false}
                                        onChange={handleChangeCheckBoxes}
                                      />
                                      <label>{el}</label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div className="row gx-3 d-flex flex-wrap align-items-center mb-5 d-none">
                            <div className="col-4">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                RADIUS Server URL
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={values.radiusUrl}
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    radiusUrl: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="col-4">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Welcome URL
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={values.welcomeUrl}
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    welcomeUrl: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="col-4">
                              <label
                                htmlFor="RestaurantPhone"
                                className="fs-md-16 mb-2 text-custom-primary"
                                style={{ fontWeight: 700 }}
                              >
                                Success URL
                              </label>
                              <input
                                required
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={values.successUrl}
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    successUrl: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="row gx-3 d-flex flex-wrap align-items-center mt-5">
                            <div className="col-4"></div>
                            <div className="col-4">
                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  style={{
                                    height: 40,
                                    width: "50%",
                                    zIndex: 0,
                                  }}
                                  className="btn btn-custom btn-custom-sm fs-16"
                                  onClick={() => handleSubmit(values)}
                                  disabled={loading || false}
                                >
                                  {loading
                                    ? details?.id
                                      ? "Updating..."
                                      : "Submitting..."
                                    : details?.id
                                    ? "Update"
                                    : "Submit"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddWifiSqueeze;
